import { CORE } from "./commonRepository";

/**
 * List of brands
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/brands', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};


/**
 * Get brand by guid
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object}
 **/
export const GetByGuid = async (guid) =>{
    try{
        const result = await CORE.get(`v1/brands/${guid}`);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Create of brands
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (modal) =>{
    try{
        const result = await CORE.post('v1/brands', modal);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Update of brands
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Update = async (modal) =>{
    try{
        const result = await CORE.put('v1/brands', modal);
        return result;
    }catch(error){
        return error.response;
    }
};
